var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ob1-cards",
        {
          staticClass: "full-height bg-white shadow-none",
          attrs: { "with-composite-link": false },
          on: {
            "ob1-cards-click": function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "a",
            {
              staticClass: "tile no-decoration",
              attrs: {
                href: _vm.mobile.detailLink,
                "data-pdb-zid": _vm.dataPdbZid + _vm.index,
                "data-pdb-sc": "adv",
                "data-pdb-idc": _vm.mobile.ean.value,
                "data-pdb-vi": _vm.dataPdbVi,
                "data-pdb-ta": _vm.mobile.advTracker,
                "data-oevent-category": "zone_recommandee_advise",
                "data-oevent-action": "bloc_" + _vm.index,
                "data-oevent-label": _vm.tagLabel(_vm.mobile.name),
              },
            },
            [
              _vm.mobile.tag
                ? _c("div", [
                    _c(
                      "strong",
                      { staticClass: "ob1-tag ob1-tag-primary tag-margin" },
                      [_vm._v(_vm._s(_vm.mobile.tag))]
                    ),
                  ])
                : _c("div", { staticClass: "pt-2" }),
              _vm._v(" "),
              _c("div", { staticClass: "px-1" }, [
                _c("div", { staticClass: "device-name" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.mobile.brand)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-center mb-0 mx-1 fw-bold device-name-wrapper",
                    },
                    [_vm._v(_vm._s(_vm.mobile.name))]
                  ),
                ]),
                _vm._v(" "),
                _vm.mobile.ean && _vm.mobile.reviewsStats
                  ? _c(
                      "div",
                      { staticClass: "bazaar-voice mb-1" },
                      [
                        _c("Rating", {
                          staticClass: "justify-content-center",
                          attrs: {
                            average: _vm.mobile.reviewsStats.average,
                            "rating-results-height": 1.375,
                          },
                        }),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "spacer-25 mb-1" }),
                _vm._v(" "),
                _c("div", { staticClass: "img-mobile text-center" }, [
                  _c(
                    "div",
                    { staticClass: "img-reco-mobile-container" },
                    [
                      _vm.mobile.image
                        ? _c("ob1-picture", {
                            attrs: { visual: _vm.mobile.image },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "infos-price" }, [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("ob1-prix-terminal", {
                          staticClass: "ob1-price-compact",
                          attrs: {
                            "multiple-price":
                              _vm.mobile.price.price.multiplePrice,
                            "total-price-with-promo":
                              _vm.mobile.price.price.totalPriceWithPromo,
                            "total-price-without-promo":
                              _vm.mobile.price.price.totalPriceWithoutPromo,
                            "order-price-label":
                              _vm.mobile.price.price.orderPriceLabel,
                            "is-cents-format": true,
                          },
                        }),
                        _vm._v(" "),
                        _vm.mobile.price.price.paymentInfoLabel
                          ? _c("cb4x-pxf-mention", {
                              attrs: {
                                "payment-info-label":
                                  _vm.mobile.price.price.paymentInfoLabel.label,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "info-advantage",
                  class: _vm.showAdvantageBloc ? "bg-greige" : "",
                },
                [
                  _vm.showAdvantageBloc
                    ? _c(
                        "div",
                        [
                          _c("advantage-bloc", {
                            attrs: {
                              "advantage-messages": _vm.advantageMessages,
                              "bonus-recovery":
                                _vm.mobile.price.advantageValues.bonusRecovery,
                              discount:
                                _vm.mobile.price.advantageValues.discount,
                              odr: _vm.mobile.price.advantageValues.odr,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _vm.mobile.dasAccessible
            ? _c("das-tooltip", {
                staticClass: "me-auto",
                attrs: {
                  id: "tooltip-reco-" + _vm.index,
                  das: _vm.mobile.dasAccessible,
                  "aria-label":
                    "DAS " + _vm.mobile.brand + " " + _vm.mobile.name,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mobile.price.price.hasInstallmentPlan
            ? _c("FundingDetailsLink", {
                attrs: {
                  "seo-id": _vm.mobile.seoId.value,
                  text: _vm.fundingDetailsDto.linkText,
                  "device-name": _vm.mobile.brand + " " + _vm.mobile.name,
                },
                on: { fundingDetailsClick: _vm.handleFundingDetailsClick },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }